import { useMutation, useQueryClient } from '@tanstack/react-query';

import { assignBillings } from '../api/AssignBillings';

interface Props {
  billingUuids: string[];
  onSuccess: () => void;
  onError: () => void;
}

export const useAssignBillings = ({
  billingUuids,
  onSuccess,
  onError,
}: Props) => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    mutationFn: () => assignBillings(billingUuids),
    onSuccess: () => {
      onSuccess();
      queryClient.invalidateQueries({ queryKey: ['billings'] });
    },
    onError,
  });

  return { assign: mutate };
};
